import styled from 'styled-components'

export const TextAreaSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
